var map = {
	"./add.svg": "5858e",
	"./cart.svg": "3c76",
	"./collect.svg": "288d",
	"./collected.svg": "3539",
	"./downLoad.svg": "2fc9",
	"./down_detail_icon.svg": "f96c",
	"./pause_icon.svg": "916a",
	"./play_icon.svg": "d287",
	"./share.svg": "36c3",
	"./similar_icon.svg": "a469"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e2fa";